<template>
  <div class="modal-dialog">
    <div class="modal-content" v-if="modalData.type === 'callback'">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">
          {{ Lang.get('js.callback_form.title') }}
        </h4>
      </div>
      <div class="modal-body">
        <form-call-back></form-call-back>
      </div>
    </div>
    <div class="modal-content" v-if="modalData.type === 'client-review'">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">
          {{ Lang.get('js.review_form.title') }}
        </h4>
      </div>
      <div class="modal-body">
        <form-client-review></form-client-review>
      </div>
    </div>
    <div class="modal-content" v-if="modalData.type === 'login'">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <auth-component></auth-component>
      </div>
    </div>
    <div class="modal-content" v-if="modalData.type === 'cart_modal'">
      <div class="modal-header">
        <button type="button" class="close" @click="closeModal">&times;</button>
        <h4 class="modal-title">
          {{ Lang.get('js.cart_success') }}
        </h4>
      </div>
      <div class="modal-body">
        <cart-modal :special-points="this.modalData.special_points" @close-cart="closeModal"></cart-modal>
      </div>
    </div>
  </div>
</template>

<script>
import FormCallBack from './forms/FormCallBack';
import FormClientReview from "./forms/FormClientReview";
import AuthComponent from './auth/AuthComponent';
import CartModal from "./order/CartModal";

export default {
  name: "modal-master",
  components: {
    FormCallBack,
    FormClientReview,
    AuthComponent,
    CartModal
  },
  props: {
    modalData: {
      required: true,
      type: Object
    },
  },
  data() {
    return {
      Lang,
      pointValue: '',
    }
  },

  methods: {
    closeModal() {
      this.modalData.type = '';
      $('#main-modal').modal('hide');
    },
  },

  mounted () {

  },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ModalMaster.vue